<template>
	<div class="replay-edit-box">
		<div class="replay-edit-wrap">
			<div v-if="editGroup">
				<div class="replay-edit-item">
					<label>组名</label>
					<input type="text" v-model="groupTitle">
				</div>
				<div class="replay-edit-item" style="margin-top: 5px;">
					<button @click="saveGroup" style="margin-left: 42px;">保存</button>
					<button style="background-color: #007DDB;" @click="editGroup = false">返回</button>
				</div>
			</div>
			<div v-else>
				<div class="replay-edit-item">
					<label>类型</label>
					<select v-model="type">
						<option value="1">文本</option>
						<option value="3">图片</option>
						<option value="4">链接</option>
						<option value="5">语音</option>
						<option value="30">视频号</option>
						<option value="31">视频直播</option>
					</select>
				</div>
				<div class="replay-edit-item">
					<label>分组</label>
					<select v-model="group">
						<option value="0">--选择分组--</option>
						<option :value="group2.id" v-for="group2 in groupList">{{group2.title}}</option>
					</select>
					<div class="replay-edit-add">
						<i @click="editGroup = true"></i>
					</div>
				</div>
				<div class="replay-edit-item">
					<label>标题</label>
					<input type="text" v-model="title">
				</div>
				<div class="replay-edit-item">
					<label>排序</label>
					<input type="number" v-model="sort">
				</div>
				<div class="replay-edit-item" v-show="type == 1 || type == 30 || type == 31">
					<label>详情</label>
					<textarea v-model="reply" :readonly="type == 30 || type == 31" ></textarea>
				</div>
				<div class="replay-edit-item" v-show="type == 4">
					<label>链标</label>
					<input type="text" v-model="link.link_title">
				</div>
				<div class="replay-edit-item" v-show="type == 4">
					<label>链述</label>
					<input type="text" v-model="link.link_desc">
				</div>
				<div class="replay-edit-item" v-show="type == 4">
					<label>链址</label>
					<input type="text" v-model="link.link_url">
				</div>
				<div class="replay-edit-item" v-show="(type == 3 || type == 4) && message.type !== undefined">
					<label>原图</label>
					<img :src="orgImage" alt="">
				</div>
				<div class="replay-edit-item" v-show="type == 3 || type == 4">
					<label>图片</label>
					<oss-img-uploader uploadType="1" uploadDir="image/reply" @oss-upload-call="ossUploadCall($event,'image')" key="OssImgUploader-cre"></oss-img-uploader>
				</div>
				<div class="replay-edit-item" v-show="type == 5">
					<label>方式</label>
					<select v-model="audio_up_type">
						<option value="1">文件上传</option>
						<option value="2">录音上传</option>
					</select>
				</div>
				<div class="replay-edit-item" v-if="type == 5">
					<label>语音</label>
					<div class="replay-edit-up" v-if="audio_up_type == 2">
						<oss-img-uploader uploadType="7" uploadDir="image/reply" @oss-upload-call="ossUploadCall($event,'audio')" :backDetail="true" key="OssImgUploader-cre2"></oss-img-uploader>
						<div style="text-align: center;"><span v-if="audio.voiceTime  === 0" style="color: red;">语音未上传/未录音</span><span v-else style="color: green;">语音已上传</span></div>
					</div>
					<div class="replay-edit-up" v-else>
						<oss-img-uploader uploadType="5" uploadDir="image/reply" @oss-upload-call="ossUploadCall($event,'audio')" :backDetail="true" :hideInfo="true" key="OssImgUploader-cre3"></oss-img-uploader>
						<audio :src="audio.voiceUrl" id="audio-data"></audio>
					</div>
				</div>
				<div class="replay-edit-item" style="margin-top: 5px;">
					<button @click="save" style="margin-left: 42px;">保存</button>
					<button @click="init()" style="background-color: #007DDB;">重置</button>
					<button class="replay-edit-close" @click="close">关闭</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import OssImgUploader from '../../../components/uploader/OssImgUploader.vue'
	import {getQuicklyReplyGroupList,saveQuicklyReply,saveQuicklyReplyGroup} from '../../../network/web/quickly-reply.js'
	import {getCurrentTime} from '../../../functions/Common.js'
	
	export default {
		name:'HomeInfoReplyEdit',
		components:{
			OssImgUploader
		},
		props:{
			message:{
				type: Object,
				default:function(){
					return{}
				}
			}
		},
		data(){
			return {
				editGroup: false,
				groupTitle: '',
				title: '',
				reply: '',
				sort: 0,
				type: 1,
				group: 0,
				audio_up_type: 1,
				image: '',
				orgImage: '',
				audio: {
					voiceTime:0,
					voiceUrl: ''
				},
				groupList: [],
				link:{
					link_title:'',
					link_desc: '',
					link_url:'http://',
					link_img:''
				}
			}
		},
		methods:{
			init(){
				this.editGroup = false
				this.groupTitle = ''
				this.title = ''
				this.reply = ''
				this.sort = 0
				this.type = 1
				this.group = 0
				this.audio_up_type = 1
				this.image = ''
				this.audio = {
					voiceTime:0,
					voiceUrl: ''
				}
				this.link = {
					link_title:'',
					link_desc: '',
					link_url:'http://',
					link_img:''
				}
			},
			
			// oss 文件上传回调
			ossUploadCall(data,type){
				if(data.length > 0){
					if(type === 'image'){
						this.image = data[0]
					}
					// 语音相关
					else{
						this.audio.voiceUrl = data[0].path
						if(data[0].duration !== undefined){
							this.audio.voiceTime = data[0].duration
						}else{
							let _this = this
							let audioObj = document.getElementById("audio-data")
							if (audioObj != null) {
								audioObj.load()
								audioObj.oncanplay = function () {
									_this.audio.voiceTime = parseInt(audioObj.duration * 1000)
								}
							}
						}
					}
				}
			},
			
			// 过滤文件格式
			filterFile(){
				for (let i = 0; i < this.uploadedFiles.length; i++) {
					let file = this.uploadedFiles[i].split("?x-oss-process")
					if(file.length > 0 && file[0] !== ""){
						uploadedFiles.push(file[0])
					}
				}
			},
			
			// 关闭按钮点击
			close(){
				this.$emit('reply-edit-call',{
					type: 'close'
				})
			},
			
			// 获取快捷语列表
			getGroups(){
				getQuicklyReplyGroupList(data=>{
					if(data.code != 1){
						return
					}
					let list = data.data
					if(list instanceof Array && list.length > 0){
						this.groupList = list
					}
				})
			},
			
			// 保存数据
			save(){
				let reply = this.reply
				if(this.type == 3){
					reply = this.image
				}else if(this.type == 4){
					reply = this.link
					reply.link_img = this.image
					reply = JSON.stringify(reply)
				}else if(this.type == 5){
					reply = JSON.stringify(this.audio)
				}
				if(reply === '' || this.title === ''){
					CHAT_LAYER.msg('标题或内容为空',{icon: 2})
					return
				}
				let param = {
					title: this.title,
					reply: reply,
					sort: this.sort,
					type: this.type,
					group: this.group
				}
				saveQuicklyReply(param,res=>{
					this.init()
					CHAT_LAYER.msg('保存成功',{icon: 1})
					this.$emit('reply-edit-call',{
						type: 'insert'
					})
				})
			},
			
			// 保存分组数据
			saveGroup(){
				if(this.groupTitle === ''){
					CHAT_LAYER.msg('分组名为空',{icon: 2})
					return
				}
				saveQuicklyReplyGroup(this.groupTitle,res=>{
					this.getGroups()
					this.editGroup = false
					CHAT_LAYER.msg('操作成功',{icon: 1})
				})
			},
			
			// 处理传进来的数据
			handleMsg(){
				if(this.message.type === undefined){
					return
				}
				let type = this.message.type
				let allowType = ['text','image','voice','link','finder','finder_live']
				if(allowType.indexOf(type) === -1){
					return
				}
				let title = '标题未定义'
				switch(type){
					case 'text':
						 this.type = 1
						 title = '文本快捷语'
						 this.reply = this.message.content
						 break
					case 'image':
						 this.type = 3
						 title = '图片快捷语'
						 this.image = this.message.content
						 this.orgImage = this.message.content
						 break
					case 'link':
					   this.type = 4
					   title = '链接快捷语'
					   let linkObj = JSON.parse(this.message.content)
					   this.link = linkObj
					   this.image = linkObj.link_img
					   this.orgImage = linkObj.link_img
					   break
					case 'voice':
						 this.type = 5
						 title = '语音快捷语'
						 break
					case 'finder':
						 this.type = 30
						 title = '视频号快捷语'
						 this.reply = this.message.content
						 break
					case 'finder_live':
						 this.type = 31
						 title = '视频直播快捷语'
						 this.reply = this.message.content
						 break
				}
				this.title = title + '(' + getCurrentTime() + ')'
				
			}
		},
		
		created() {
			this.getGroups()
			this.handleMsg()
		}
	}
</script>

<style scoped="scoped">
	.replay-edit-box{
		position: absolute;
		top: 84px;
		bottom: 0;
		left: 10px;
		right: 10px;
	}
	.replay-edit-box .replay-edit-wrap{
		max-width: 600px;
		height: 100%;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.replay-edit-wrap .replay-edit-item{
		padding: 5px;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		color: #666666;
		min-height: 30px;
	}
	.replay-edit-item label{
		width: 32px;
		margin-right: 10px;
	}
	.replay-edit-item input{
		height: 30px;
		border: 1px solid #dedede;
		flex-grow: 1;
		width: 0;
		padding: 0 5px;
		box-sizing: border-box;
		color: #666666;
	}
	.replay-edit-item input:focus{
		border: 1px solid #2bad37;
	}
	.replay-edit-item select{
		flex-grow: 1;
		width: 0;
		height: 30px;
		border: 1px solid #dedede;
		color: #666666;
		cursor: pointer;
	}
	.replay-edit-item textarea{
		border: 1px solid #dedede;
		flex-grow: 1;
		width: 0;
		height: 60px;
		line-height: 20px;
		resize: none;
		padding: 5px;
		border-radius: 4px;
		color: #666666;
	}
	.replay-edit-item textarea:focus{
		border: 1px solid #2bad37;
	}
	.replay-edit-item .replay-edit-add{
		width: 26px;
		height: 26px;
		margin-left: 5px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}
	.replay-edit-add i {
		width: 24px;
		height: 24px;
		display: block;
		background-image: url(../../../assets/img/add-icon-2bad37-32.png);
		background-position: center;
		background-repeat: no-repeat;
		background-size: 24px auto;
	}
	.replay-edit-up{
		width: 0;
		flex-grow: 1;
		border: 1px solid #dedede;
		padding-bottom: 5px;
		background-color: #efefef;
	}
	.replay-edit-up > .comp-u-container{
		/* margin: 0; */
	}
	.replay-edit-item button{
		padding: 4px 14px;
		background-color: #2bad37;
		color: #FFFFFF;
		border-radius: 4px;
		cursor: pointer;
		margin: 0 6px;
	}
	.replay-edit-item .replay-edit-close{
		background-color: #ff2d2d;
	}
	.replay-edit-item > img{
		width: 86px;
		height: 86px;
		border-radius: 4px;
	}
	.replay-edit-item > .comp-u-container{
		margin: 0 !important;
		margin-left: -5px !important;
	}
</style>
